module.exports = __webpack_public_path__ + "img/plus.12c2aef8.svg";